import type { DropzoneOptions } from "react-dropzone";
import { NotificationType } from "../../notification/constants";
import { validateImage } from "./validateImage";

interface Options {
    upload: (value: File) => void;
    addNotification: (value: NotificationType) => void;
}

export const useFileDropHandler = ({ upload, addNotification }: Options) => {
    const handleFileDrop: DropzoneOptions["onDrop"] = async (acceptedFiles) => {
        // loop each file to validate photos
        for await (let file of acceptedFiles) {
            // check if photo can be loaded, with correct dimensions
            const validDimensions = await validateImage(file);
            if (!validDimensions) return addNotification(NotificationType.RequirementNotMet);

            // call to upload
            upload(file);
        }
    };

    return {
        handleFileDrop,
    };
};
